<template>
    <div class="container p-5">
        <div class="container">
            <h3 class="tNormal mb-5">خلاصه سفارش</h3>
            <!-- <table>
                <tr>
                    <th>تصویر محصول</th>
                    <th>نام محصول</th>
                    <th>تعداد</th>
                    <th>قیمت</th>
                </tr>
            </table> -->
                <order-item v-for="(item,i) in (items != null ? items.product : [])" :key="i" :theItem="item"></order-item>

            <div class="mt-3" v-if="items != null">
                <p>نام کاربر</p>
                <p class="tLighter">{{(items.user_name ? items.user_name : '')}}</p>
                <p>توضیحات سفارش</p>
                <p class="tLighter">{{items.desc}}</p>
                <p class="red" v-if="items.unknown && items.unknown">*** این سفارش باید به صورت ناشناس ارسال گردد</p>
                <p>آدرس سفارش</p>
                <p class="tLighter">{{items.user_address}}</p>
                <p>شماره تلفن</p>
                <p class="tLighter">{{items.user_phone}}</p>
                <p v-if="items.user_lat">لینک آدرس :</p>
                <a v-if="items.user_lat" :href="'https://www.google.com/maps/search/?api=1&query='+items.user_lat + ',' + items.user_long">‍‍‍‍{{'https://www.google.com/maps/search/?api=1&query='+items.user_lat + ',' + items.user_long}}</a>
                <p>زمان تحویل :</p>
                <p class="tLighter">{{items.delivery_day + " " +items.delivery_time}}</p>
                <p v-if="items.receiver_name">فرد تحویل گیرنده :</p>
                <p v-if="items.receiver_name" class="tLighter">{{items.receiver_name}}</p>
                <p v-if="items.receiver_name">شماره تلفن تحویل گیرنده :</p>
                <p v-if="items.receiver_name" class="tLighter">{{items.receiver_mobile}}</p>
            </div>
        </div>
    </div>
</template>
<script>
import { computed, onMounted, ref} from "@vue/composition-api"
import OrderItem from './partials/OrderItem'
import Service from '../../../utils/admin-service'
import jalalim from 'jalali-moment'
export default {
    components:{
        OrderItem
    },
    setup(props,context){
        const items = ref(null)
        const times = ref(null)
        const theOrderId = computed(()=>{
            return context.root.$route.params.id
        })
        const authService = computed(()=>{
            return Service(true)
        })

        const errorHandler = (e)=>{

        }

        onMounted(()=>{
            
            authService.value.receive('admin/order/' + theOrderId.value , {} , (s,d)=>{
                if(s == 200){
                    items.value = d.data
                    if(items.value.delivery_day != ""){
                        authService.value.receive('admin/preorder/time',{},(s,d)=>{
                            times.value = d.data
                            items.value.delivery_day = jalalim(items.value.delivery_day).locale('fa').format('YY-MM-DD')
                            times.value.map((t)=>{
                                if(t.id == parseInt(items.value.delivery_time)){
                                    items.value.delivery_time = ' از ساعت ' + t.from + ' تا ' + t.to
                                }
                            })
                        },errorHandler)
                    }
                }
            },(s,e)=>{

            })
        })
        return {items}
    }
}
</script>
<style scoped>
.summary{
    background-color: #fff;
    font-size: 0.9rem;
    font-weight: lighter;
}

table{
    border-collapse: separate;
    border-spacing: 0px;
    width: 100%;
    table-layout: auto;
}

td{
    border: 1px solid rgba(127,127,127,0.2);
    white-space: nowrap;
    padding-right: 1rem;
    text-align: center;
}

th{
    text-align: center;
    padding: 1rem ;
}

tr{
    width: 100%;
}

.big-cell{
    width: 75%;
    padding:0.5rem 1rem 0.5rem 1rem;
}

.small-cell{
    width: 25%;
    padding:0.5rem 1rem 0.5rem 1rem;
}

.accounts{
    border-top: 1px solid rgba(127,127,127,0.2);
}
 
.red{
    color: red;
}
</style>